module.exports = __webpack_public_path__ + "img/networking.a32ac2ef.svg";